import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.values.js";
import React from 'react';
import { matchPath, useLocation } from 'react-router';
import TooltipButton from 'components/TooltipButton';
import useBreakpoints from 'hooks/useBreakpoints';
import useCustomContactLink from 'hooks/useCustomContactLink';
import { DEFAULT_EDIT_PLAYLIST_ROUTES } from 'screens/SinglePlaylistManager';
import { COACH_AI_ROUTE } from 'utils/routes';

/**
 * On pages with other important controls near the bottom edge
 * of the screen, we don't want to render the floating contact button
 */
var PATHS_WITHOUT_FLOATING_BUTTON = [].concat(_toConsumableArray(Object.values(DEFAULT_EDIT_PLAYLIST_ROUTES)), [COACH_AI_ROUTE]);
function FloatingContactButton() {
  var _useCustomContactLink = useCustomContactLink(),
    openModal = _useCustomContactLink.openModal,
    url = _useCustomContactLink.url,
    title = _useCustomContactLink.title;
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var hideFloatingButton = matchPath(String(pathname).toLowerCase(), PATHS_WITHOUT_FLOATING_BUTTON);
  var _useBreakpoints = useBreakpoints(),
    isDesktop = _useBreakpoints.xl;
  if (!isDesktop && hideFloatingButton) {
    return null;
  }
  var buttonProps = {
    round: true,
    variant: 'important',
    icon: 'chat',
    position: 'fixed',
    bottom: 'm',
    right: 'm',
    z: 'navbars',
    title: title,
    tooltipPlacement: 'top-end'
  };
  if (url) {
    return /*#__PURE__*/React.createElement(TooltipButton, _extends({}, buttonProps, {
      as: "a",
      href: url,
      target: "_blank"
    }));
  } else {
    return /*#__PURE__*/React.createElement(TooltipButton, _extends({}, buttonProps, {
      as: "button",
      onClick: openModal
    }));
  }
}
export default FloatingContactButton;